// Times and dates the masjid's way, from its General Settings: time format
// 1 = "7:30 pm" (the default), 2 = "19:30"; date format 1 = "05 Nov 2026",
// 2 = "2026 11 05", 3 = "05/11/2026". The websites use the same rules
// (backend services/masjidFormat.ts).
import { useMemo } from "react";
import { useGetGeneralSettingsQuery } from "../store/Reducer/user-setting";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "19:30", "19:30 (BST)" -> "7:30 pm" / "19:30"; anything else -> "".
export const formatTime = (value, timeFormat = 1) => {
  const m = String(value || "").match(/(\d{1,2}):(\d{2})/);
  if (!m) return "";
  const h = Number(m[1]);
  if (timeFormat === 2) return `${String(h).padStart(2, "0")}:${m[2]}`;
  return `${h % 12 || 12}:${m[2]} ${h < 12 ? "am" : "pm"}`;
};

// "05-11-2026" (or with slashes) -> the masjid's date format.
export const formatDate = (dashed, dateFormat = 1) => {
  const [d, mo, y] = String(dashed || "").split(/[-/.]/);
  if (!d || !mo || !y) return dashed || "";
  const dd = d.padStart(2, "0");
  const mm = mo.padStart(2, "0");
  if (dateFormat === 2) return `${y} ${mm} ${dd}`;
  if (dateFormat === 3) return `${dd}/${mm}/${y}`;
  return `${dd} ${MONTHS[Number(mo) - 1] || mm} ${y}`;
};

export default function useMasjidFormat() {
  const { data } = useGetGeneralSettingsQuery();
  const timeFormat = data?.data?.timeFormat === 2 ? 2 : 1;
  const dateFormat = [1, 2, 3].includes(data?.data?.dateFormat) ? data.data.dateFormat : 1;
  return useMemo(
    () => ({
      time: (value) => formatTime(value, timeFormat),
      date: (dashed) => formatDate(dashed, dateFormat),
    }),
    [timeFormat, dateFormat]
  );
}
